import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import AppLogo from '../components/AppLogo';

const Icon = {
  Brick: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="6" rx="1" /><rect x="3" y="14" width="18" height="6" rx="1" />
      <path d="M9 4v6M15 14v6M9 14v6M15 4v6" />
    </svg>
  ),
  Ruler: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 3 3 21l-2-2L19 1z" /><path d="M14 6l2 2M11 9l2 2M8 12l2 2M5 15l2 2" />
    </svg>
  ),
  Home: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12l9-9 9 9" /><path d="M5 10v10h14V10" /><path d="M9 20v-6h6v6" />
    </svg>
  ),
  Palette: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="13.5" cy="6.5" r="1.5" /><circle cx="17.5" cy="10.5" r="1.5" /><circle cx="8.5" cy="7.5" r="1.5" /><circle cx="6.5" cy="12.5" r="1.5" />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c1.4 0 2-1 2-2 0-.5-.2-1-.5-1.4-.3-.4-.5-.9-.5-1.4 0-1.1.9-2 2-2h2c2.8 0 5-2.2 5-5C22 5.6 17.5 2 12 2z" />
    </svg>
  ),
  PDF: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" />
      <path d="M9 13h1.5a1.5 1.5 0 1 1 0 3H9zM14 13h2v3h-2zM9 16v2M14 16v2" />
    </svg>
  ),
  Tools: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  ),
  Pencil: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4z" />
    </svg>
  ),
  Map: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" /><line x1="8" y1="2" x2="8" y2="18" /><line x1="16" y1="6" x2="16" y2="22" />
    </svg>
  ),
  Cement: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7h16l-1 13H5z" /><path d="M9 7V4h6v3" /><path d="M8 12h8" />
    </svg>
  ),
  Steel: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12h18" /><path d="M3 6h18" /><path d="M3 18h18" /><circle cx="6" cy="6" r="1" /><circle cx="6" cy="12" r="1" /><circle cx="6" cy="18" r="1" />
    </svg>
  ),
  Tile: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="8" height="8" rx="1" /><rect x="13" y="3" width="8" height="8" rx="1" /><rect x="3" y="13" width="8" height="8" rx="1" /><rect x="13" y="13" width="8" height="8" rx="1" />
    </svg>
  ),
  Roof: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 12 12 4l10 8" /><path d="M5 10v10h14V10" />
    </svg>
  ),
  Coin: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" /><path d="M12 7v10M9 9.5c.5-1.5 5-2 5 0s-5 1-5 3 4.5 1.5 5 0" />
    </svg>
  ),
  Box: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),
  Plus: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Apple: () => (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.86-3.08.4-1.09-.47-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>
  ),
  Play: () => (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M3.6 1.7c-.4.3-.6.8-.6 1.4v17.8c0 .6.2 1.1.6 1.4l9.7-9.7L3.6 1.7zm10.8 10.8 2.7 2.7-12 6.8 9.3-9.5zM3.6 1.7l9.7 9.5 2.7-2.7L3.6 1.7zm14.7 8.6 2.7 1.6c.7.4.7 1.4 0 1.8l-2.7 1.6-2.9-2.5 2.9-2.5z"/></svg>
  ),
  Download: () => (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>
  ),
};

const features = [
  { icon: <Icon.Brick />, title: 'Material Estimator', text: 'Calculate cement, sand, bricks, blocks and steel in seconds.', wide: true },
  { icon: <Icon.Ruler />, title: 'Smart Calculations', text: 'Concrete, plaster, tile and roof formulas built in.' },
  { icon: <Icon.Home />, title: '3D Templates', text: '1, 2 and 3 bedroom apartment layouts ready to explore.' },
  { icon: <Icon.Palette />, title: 'Design Gallery', text: 'Interior & exterior inspiration: kitchen, bath, gates, gardens.' },
  { icon: <Icon.PDF />, title: 'PDF Reports', text: 'Export and share professional estimates with one tap.' },
  { icon: <Icon.Tools />, title: 'Built for the Field', text: 'Works offline. Fast. Lightweight. No clutter.' },
  { icon: <Icon.Pencil />, title: 'Draw Plan', text: 'Sketch quick layouts and rooms right inside the app.' },
  { icon: <Icon.Map />, title: 'Floor Plan', text: 'Create scaled floor plans with walls, doors and dimensions.', wide: true },
];

const stats = [
  { value: '50K+', label: 'Active users' },
  { value: '4.7★', label: 'Average rating' },
  { value: '30+', label: 'Calculators' },
  { value: '100%', label: 'Offline ready' },
];

const steps = [
  { n: '01', title: 'Download the app', text: 'Get the app free from Google Play or the App Store.' },
  { n: '02', title: 'Pick your tool', text: 'Choose a calculator, template or design gallery.' },
  { n: '03', title: 'Get instant results', text: 'See costs, materials and PDF reports in seconds.' },
];

const testimonials = [
  { name: 'Ahmed R.', role: 'Civil Engineer', text: 'Replaced three of my old apps. The concrete and steel calculators alone save me hours every week.' },
  { name: 'Sara K.', role: 'Homeowner', text: 'I used the floor plan and design gallery to plan my renovation. Super easy, even for a non-builder.' },
  { name: 'Bilal M.', role: 'Contractor', text: 'PDF reports look professional. Clients love them. Best construction app I have used.' },
  { name: 'Fatima H.', role: 'Architect', text: 'The 3D templates are a great starting point. Saves hours when scoping a small residential job.' },
  { name: 'Junaid A.', role: 'Site Engineer', text: 'Steel bar bending schedule and concrete mix design — all in one app. No more spreadsheets on site.' },
  { name: 'Maria L.', role: 'Interior Designer', text: 'The design gallery is a goldmine. I show clients ideas straight from my phone.' },
];

const calculators = [
  {
    key: 'concrete',
    icon: <Icon.Cement />,
    title: 'Concrete',
    sub: 'Volume + materials',
    inputs: [
      { label: 'Length', value: '5.0', unit: 'm' },
      { label: 'Width', value: '4.0', unit: 'm' },
      { label: 'Depth', value: '0.15', unit: 'm' },
      { label: 'Mix ratio', value: '1:2:4', unit: '' },
    ],
    results: [
      { icon: <Icon.Box />, value: '3.0', unit: 'm³', label: 'Concrete' },
      { icon: <Icon.Cement />, value: '13', unit: 'bags', label: 'Cement' },
      { icon: <Icon.Coin />, value: '$540', unit: '', label: 'Estimate' },
    ],
  },
  {
    key: 'bricks',
    icon: <Icon.Brick />,
    title: 'Brickwork',
    sub: 'Bricks + mortar',
    inputs: [
      { label: 'Wall length', value: '6.0', unit: 'm' },
      { label: 'Wall height', value: '3.0', unit: 'm' },
      { label: 'Thickness', value: '230', unit: 'mm' },
      { label: 'Brick size', value: '230x110x76', unit: 'mm' },
    ],
    results: [
      { icon: <Icon.Brick />, value: '2,450', unit: '', label: 'Bricks' },
      { icon: <Icon.Cement />, value: '8', unit: 'bags', label: 'Cement' },
      { icon: <Icon.Coin />, value: '$310', unit: '', label: 'Estimate' },
    ],
  },
  {
    key: 'steel',
    icon: <Icon.Steel />,
    title: 'Steel & Rebar',
    sub: 'Bar bending schedule',
    inputs: [
      { label: 'Member', value: 'Beam', unit: '' },
      { label: 'Length', value: '4.5', unit: 'm' },
      { label: 'Bar dia', value: '12', unit: 'mm' },
      { label: 'Quantity', value: '6', unit: 'bars' },
    ],
    results: [
      { icon: <Icon.Steel />, value: '24', unit: 'kg', label: 'Total weight' },
      { icon: <Icon.Box />, value: '27', unit: 'm', label: 'Cut length' },
      { icon: <Icon.Coin />, value: '$48', unit: '', label: 'Estimate' },
    ],
  },
  {
    key: 'tile',
    icon: <Icon.Tile />,
    title: 'Tile & Flooring',
    sub: 'Coverage + waste',
    inputs: [
      { label: 'Room area', value: '24', unit: 'm²' },
      { label: 'Tile size', value: '600x600', unit: 'mm' },
      { label: 'Wastage', value: '8', unit: '%' },
      { label: 'Pattern', value: 'Straight', unit: '' },
    ],
    results: [
      { icon: <Icon.Tile />, value: '72', unit: 'tiles', label: 'Required' },
      { icon: <Icon.Box />, value: '12', unit: 'boxes', label: 'To buy' },
      { icon: <Icon.Coin />, value: '$420', unit: '', label: 'Estimate' },
    ],
  },
  {
    key: 'roof',
    icon: <Icon.Roof />,
    title: 'Roof & Plaster',
    sub: 'Surface area & cost',
    inputs: [
      { label: 'Length', value: '12', unit: 'm' },
      { label: 'Width', value: '8', unit: 'm' },
      { label: 'Pitch', value: '15°', unit: '' },
      { label: 'Material', value: 'Metal', unit: '' },
    ],
    results: [
      { icon: <Icon.Roof />, value: '99', unit: 'm²', label: 'Surface' },
      { icon: <Icon.Box />, value: '110', unit: 'sheets', label: 'Sheets' },
      { icon: <Icon.Coin />, value: '$1.2k', unit: '', label: 'Estimate' },
    ],
  },
];

const faqs = [
  { q: 'Is Construction Calculator free to use?', a: 'Yes. The core calculators, templates and design gallery are all free. Some advanced templates may be available as in-app purchases.' },
  { q: 'Does the app work offline?', a: 'Absolutely. All calculators and templates are bundled with the app, so you can run estimates on a job site with no signal at all.' },
  { q: 'Which units does it support?', a: 'Both metric and imperial. Switch in settings — every calculator updates automatically with no manual conversion.' },
  { q: 'Can I export estimates as PDF?', a: 'Yes. Every calculator and floor plan can be exported to a clean, branded PDF report you can email or print directly from your phone.' },
  { q: 'Is my data private?', a: "All your projects stay on your device. Nothing is uploaded unless you explicitly share an estimate. See our privacy policy for full details." },
  { q: 'Which platforms are supported?', a: 'Construction Calculator is available on Android (Google Play) and iOS (App Store). One install, all features.' },
];

const rotatingWords = ['estimates.', 'floor plans.', 'PDF reports.', 'rebar schedules.'];

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal, .reveal-stagger');
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function Rotator() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % rotatingWords.length), 2400);
    return () => clearInterval(t);
  }, []);
  return (
    <span className="rotator">
      <span key={i} className="rotator-item">{rotatingWords[i]}</span>
    </span>
  );
}

function CalculatorShowcase() {
  const [active, setActive] = useState(0);
  const calc = calculators[active];
  return (
    <div className="calc-showcase">
      <div className="calc-tabs">
        {calculators.map((c, idx) => (
          <button
            key={c.key}
            className={`calc-tab ${idx === active ? 'active' : ''}`}
            onClick={() => setActive(idx)}
            aria-pressed={idx === active}
          >
            <span className="calc-tab-icon">{c.icon}</span>
            <span className="calc-tab-text">
              <strong>{c.title}</strong>
              <span>{c.sub}</span>
            </span>
          </button>
        ))}
      </div>

      <div className="calc-panel" key={calc.key}>
        <div className="calc-panel-header">
          <h3>{calc.title}</h3>
          <span className="calc-pill">Live preview</span>
        </div>
        <div className="calc-inputs">
          {calc.inputs.map((inp) => (
            <div className="calc-input" key={inp.label}>
              <label>{inp.label}</label>
              <span className="calc-value">{inp.value}<span className="calc-unit">{inp.unit && ` ${inp.unit}`}</span></span>
            </div>
          ))}
        </div>
        <div className="calc-results">
          {calc.results.map((r) => (
            <div className="calc-result" key={r.label}>
              <div className="calc-result-icon">{r.icon}</div>
              <strong>{r.value}{r.unit && <span style={{ fontSize: '0.85rem', color: 'var(--muted)', fontWeight: 600, marginLeft: 4 }}>{r.unit}</span>}</strong>
              <span>{r.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="faq-list">
      {faqs.map((f, i) => (
        <div key={f.q} className={`faq-item ${open === i ? 'open' : ''}`}>
          <button
            className="faq-q"
            onClick={() => setOpen(open === i ? -1 : i)}
            aria-expanded={open === i}
          >
            {f.q}
            <span className="faq-icon"><Icon.Plus /></span>
          </button>
          <div className="faq-a">
            <div className="faq-a-inner">{f.a}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function Home() {
  useReveal();
  const marqueeRef = useRef(null);

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <div className="container hero-grid">
          <div className="reveal">
            <span className="badge">
              <span className="badge-pulse" />
              New · Floor Plan &amp; Draw Plan tools
            </span>
            <h1>
              Build smarter with{' '}
              <span className="gradient-text">accurate</span>
              <br />
              <Rotator />
            </h1>
            <p className="hero-sub">
              Smart calculators, ready-to-use design templates and pro-grade PDF reports —
              everything builders, engineers and homeowners need, right in your pocket.
            </p>
            <div className="hero-buttons">
              <Link to="/download" className="btn btn-primary">
                <Icon.Download /> Download Now
              </Link>
              <Link to="/about" className="btn btn-outline">
                Learn More
              </Link>
            </div>

            <div className="hero-rating">
              <span className="stars-row">★★★★★</span>
              <span><strong>4.7</strong> from 12,000+ reviews</span>
            </div>

            <div className="hero-stats">
              {stats.map((s) => (
                <div key={s.label} className="hero-stat">
                  <div className="hero-stat-value">{s.value}</div>
                  <div className="hero-stat-label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="hero-visual reveal">
            <div className="phone-floating-pill pill-top-right">
              <span className="dot" /> Estimate ready
            </div>
            <div className="phone-floating-pill pill-bottom-left">
              <Icon.PDF /> PDF exported
            </div>
            <div className="phone-frame">
              <div className="phone-screen">
                <div className="phone-app-header">
                  <AppLogo className="phone-app-logo" alt="Construction Calculator app logo" />
                  <div>
                    <strong>Construction Calculator</strong>
                    <span>Project dashboard</span>
                  </div>
                </div>
                <div className="phone-card phone-card-1">
                  <div className="phone-icon"><Icon.Brick /></div>
                  <div>
                    <strong>Brick Estimator</strong>
                    <span>2,450 bricks</span>
                  </div>
                </div>
                <div className="phone-card phone-card-2">
                  <div className="phone-icon"><Icon.Ruler /></div>
                  <div>
                    <strong>Concrete</strong>
                    <span>12.5 m³</span>
                  </div>
                </div>
                <div className="phone-card phone-card-3">
                  <div className="phone-icon"><Icon.Map /></div>
                  <div>
                    <strong>Floor Plan</strong>
                    <span>3 BHK · 1450 ft²</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST STRIP */}
      <section className="logo-strip">
        <div className="container">
          <div className="logo-strip-label">Used by builders & engineers worldwide</div>
          <div className="marquee-track">
            <div className="marquee" ref={marqueeRef}>
              {['BuildCo', 'StructureLab', 'Civilworks', 'BlueprintHQ', 'FieldFox', 'MasonPro', 'SitePulse', 'BuildCo', 'StructureLab', 'Civilworks', 'BlueprintHQ', 'FieldFox', 'MasonPro', 'SitePulse'].map((name, i) => (
                <span key={i}>{name}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="section">
        <div className="container">
          <span className="eyebrow reveal">Features</span>
          <h2 className="reveal">Everything you need on a job site</h2>
          <p className="lead reveal">
            From bricks to budgets, Construction Calculator gives you the tools to plan, estimate
            and visualize any construction project.
          </p>
          <div className="features-bento reveal-stagger">
            {features.map((f) => (
              <div className={`feature-card ${f.wide ? 'feature-wide' : ''}`} key={f.title}>
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CALCULATOR SHOWCASE */}
      <section className="section section-alt">
        <div className="container">
          <span className="eyebrow reveal">Live preview</span>
          <h2 className="reveal">Try the calculators in seconds</h2>
          <p className="lead reveal">
            Enter dimensions, get materials, costs and a shareable PDF — no spreadsheets, no formulas to memorize.
          </p>
          <div className="reveal">
            <CalculatorShowcase />
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="section">
        <div className="container">
          <span className="eyebrow reveal">How it works</span>
          <h2 className="reveal">From download to done in 3 steps</h2>
          <p className="lead reveal">Simple, fast and built for the way you actually work.</p>
          <div className="steps-grid reveal-stagger">
            {steps.map((s) => (
              <div className="step-card" key={s.n}>
                <div className="step-number">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="section section-dark">
        <div className="container">
          <span className="eyebrow reveal">Testimonials</span>
          <h2 className="reveal">Loved by builders and homeowners</h2>
          <p className="lead reveal">Real reviews from people using Construction Calculator every day.</p>
        </div>
        <div className="testimonial-marquee-wrap reveal">
          <div className="testimonial-marquee">
            {[...testimonials, ...testimonials].map((t, i) => (
              <div className="testimonial-card" key={i}>
                <div className="stars">★★★★★</div>
                <p className="quote">"{t.text}"</p>
                <div className="author">
                  <div className="avatar">{t.name.charAt(0)}</div>
                  <div>
                    <strong>{t.name}</strong>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <div className="container">
          <span className="eyebrow reveal">FAQ</span>
          <h2 className="reveal">Questions, answered</h2>
          <p className="lead reveal">Everything you might be wondering before you install.</p>
          <div className="reveal">
            <FAQ />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container cta-inner">
          <h2 className="reveal">Ready to build smarter?</h2>
          <p className="reveal">
            Join thousands of builders using Construction Calculator every day. Free on Android and iOS.
          </p>
          <div className="cta-store-row reveal">
            <a href="https://play.google.com/store/apps/details?id=com.fairappsstore.construction_calculator" target="_blank" rel="noopener noreferrer" className="store-badge">
              <Icon.Play />
              <span>
                <span className="small">Get it on</span>
                <span className="big">Google Play</span>
              </span>
            </a>
            <a href="https://apps.apple.com/app/id6763050323" target="_blank" rel="noopener noreferrer" className="store-badge">
              <Icon.Apple />
              <span>
                <span className="small">Download on the</span>
                <span className="big">App Store</span>
              </span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
